import axios from "axios";
import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { environment } from "../../environment";
import { Link } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Country, State, City } from "country-state-city";
import "./LeadExecutive/leadexecutive.css";
import NavbarNew from "../Components/NavbarNew";

const MySwal = withReactContent(Swal);

const AddUserSysAdmin = ({ history, match }) => {
  const [name, setname] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [role, setrole] = useState({});
  const [email, setmail] = useState("");
  const [phone, setphone] = useState("");
  const [dob, setdob] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [countrycode, setCountryCode] = useState("");
  const [dap_states, setDapState] = useState([]);
  const [dap_countries, setDapCountries] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [poststate, setPostState] = useState("");
  const [postcity, setPostCity] = useState("");
  const [zip, setzip] = useState("");
  const [address, setAddress] = useState("");
  const [pwd, setpassword] = useState("");
  const [nameErrors, setNameErrors] = useState({});
  const [fnameErrors, setFNameErrors] = useState({});
  const [lnameErrors, setLNameErrors] = useState({});
  const [roleErrors, setroleErrors] = useState({});
  const [emailErrors, setemailErrors] = useState({});
  const [passwordErrors, setpasswordErrors] = useState({});
  const [phoneErrors, setphoneErrors] = useState({});
  const [typeErrors, settypeErrors] = useState({});
  const [organization, setOrganization] = useState("");
  const [showOrganization, setShowOrganization] = useState("none");
  const [showPassword, setShowPassword] = useState("block");
  const [showActivationLink, setshowActivationLink] = useState("none");
  const [type, setType] = useState({});
  let roles = [];
  const userKaData = JSON.parse(localStorage.getItem("user"));

  roles = [
    // {
    //   role: "Lead Executive",
    //   role_value: "LEAD_EXECUTIVE",
    // },
    {
      role: "Support Admin",
      role_value: "SUPPORT_ADMIN",
    },
    {
      role: "IT Executive",
      role_value: "IT_EXECUTIVE",
    },
    {
      role: "Vendor",
      role_value: "VENDOR",
    },
    {
      role: "PARTNER",
      role_value: "PARTNER",
    },
    {
      role: "LOGISTIC MANAGER",
      role_value: "LOGISTIC_MANAGER",
    },
  ];

  let activationlink = [];
  activationlink = [
    {
      type: "Show Activation Link",
      type_id: "show_link",
    },
    {
      type: "Send Activation Link",
      type_id: "send_link",
    },
  ];
  // useEffect(() => {
  //   let isPartner = localStorage.getItem("partnerDetails").userType;
  //   if (isPartner == "PARTNER") {
  //     roles = [
  //       {
  //         role: "Lead Executive",
  //         role_value: "LEAD_EXECUTIVE",
  //       },
  //       {
  //         role: "Support Admin",
  //         role_value: "SUPPORT_ADMIN",
  //       },
  //       {
  //         role: "IT Executive",
  //         role_value: "IT_EXECUTIVE",
  //       },
  //       {
  //         role: "Vendor",
  //         role_value: "VENDOR",
  //       },
  //       {
  //         role: "LOGISTIC MANAGER",
  //         role_value: "LOGISTIC_MANAGER",
  //       },
  //     ];
  //   }
  // }, []);

  let countries = [];
  countries = Country.getAllCountries();
  const selectCountry = (e) => {
    setDapCountries(Country.getAllCountries());
    setDapState(State.getStatesOfCountry(e.id));
    setCountryCode(e.id);
    setPostCountry(e.label);
  };
  const selectRegion = (e) => {
    setDapCity(City.getCitiesOfState(countrycode, e.id));
    setPostState(e.label);
  };
  const selectCity = (e) => {
    setPostCity(e.label);
  };
  const formValidation = () => {
    let isValid = true;
    const fnameErrors = {};
    const lnameErrors = {};
    const roleErrors = {};
    const emailErrors = {};
    const passwordErrors = {};
    const phoneErrors = {};
    const typeErrors = {};
    setNameErrors("");
    setroleErrors("");
    setemailErrors("");
    setroleErrors("");
    setphoneErrors("");
    settypeErrors("");
    // if (name == "") {
    //   nameErrors.noName = "Name is required";
    //   isValid = false;
    //   setNameErrors(nameErrors);
    // }

    if (fname == "") {
      fnameErrors.noName = "First name is required";
      isValid = false;
      setFNameErrors(fnameErrors);
    }

    if (lname == "") {
      lnameErrors.noName = "Last name is required";
      isValid = false;
      setLNameErrors(lnameErrors);
    }
    if (Object.keys(role).length == 0) {
      roleErrors.noName = "Role is required";
      isValid = false;
      setroleErrors(roleErrors);
    }
    if (email == "") {
      emailErrors.noName = "Email is required";
      isValid = false;
      setemailErrors(emailErrors);
    }
    if (role.value != "PARTNER") {
      if (pwd == "") {
        passwordErrors.noName = "Password is required";
        isValid = false;
        setpasswordErrors(passwordErrors);
      }
    }
    if (email != "") {
      let validRegex =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (!email.match(validRegex)) {
        emailErrors.noName = "Provide a Proper Email";
        isValid = false;
        setemailErrors(emailErrors);
      }
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      emailErrors.noName = "Provide a Proper Email";
      isValid = false;
      setemailErrors(emailErrors);
    }
    if (phone != "") {
      var phoneno = /^\d{10}$/;
      if (!phone.match(phoneno)) {
        phoneErrors.noName = "Provide a Proper Phone No.";
        isValid = false;
        setphoneErrors(phoneErrors);
      }
    }
    if (role.value == "PARTNER") {
      if (Object.keys(type).length == 0) {
        typeErrors.noName = "ActivationLink is required";
        isValid = false;
        settypeErrors(typeErrors);
      }
    }
    return isValid;
  };
  const setType1 = (e) => {
    setType({ label: e.label, value: e.value });
  };
  const AddLeadExecutive = () => {
    let validform = formValidation();
    if (validform) {
      let user = JSON.parse(localStorage.getItem("user"));
      axios
        .post(environment.dap_url + "crm_api/createUser", {
          email: email,
          password: pwd,
          userFirstName: fname,
          userLastName: lname,
          city: postcity,
          state: poststate,
          country: postcountry,
          zip: zip,
          address: address,
          phone: phone,
          DOB: dob,
          userType: role.value,
          organization: organization,
          createdBy: user._id,
          parentId: user._id,
          // type: type,
        })
        .then((res) => {
          if (res.data.error) {
            MySwal.fire({
              title: <p>Given Mail id already exist</p>,
              type: "success",
            });
          } else {
            if (role.value == "PARTNER") {
              MySwal.fire({
                title:
                  window.location.origin +
                  "/passwordCreate/" +
                  res.data.data._id,
                type: "success",
                showCancelButton: true,
                confirmButtonText: "Change Password",
              }).then(function (result) {
                MySwal.fire({
                  title: <p>User Added</p>,
                  type: "success",
                });
                history.push("/manage-users");
              });
            } else {
              MySwal.fire({
                title: <p>User Added</p>,
                type: "success",
              });
              history.push("/manage-users");
            }
          }
        })
        .catch((err) => {
          console.log(err);
          MySwal.fire({
            title: <p>{err?.response?.data?.message}</p>,
            type: "error",
          });
        });
    }
  };
  const setrole1 = (e) => {
    console.log(e.label, e.value);
    if (e.value == "PARTNER") {
      setShowOrganization("block");
      setShowPassword("none");
      setshowActivationLink("block");
    } else {
      setshowActivationLink("none");
      setShowOrganization("none");
      setShowPassword("block");
    }
    setrole({ label: e.label, value: e.value });
  };
  return (
    <>
      <div className="container-fluid">
        <NavbarNew />
        <Link to="/manage-users" className="btn btn-light my-3">
          Go Back
        </Link>
        <div className="container-fluid">
          <h3 className="text-center">Add User</h3>
          <div className="card-body">
            <div className="row">
              {/* <div className="col-md-6">
                    <Form.Group controlId="consignee">
                      <Form.Label>Name*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Name"
                        required
                        value={name}
                        onChange={(e) => setname(e.target.value)}
                      ></Form.Control>
                      <div>
                        {Object.keys(nameErrors).map((key) => {
                          return (
                            <div style={{ color: "red" }}>
                              {nameErrors[key]}
                            </div>
                          );
                        })}
                      </div>
                    </Form.Group>
                  </div> */}
              <div className="col-md-6">
                <Form.Group controlId="consignee">
                  <Form.Label>Email*</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setmail(e.target.value)}
                  ></Form.Control>
                  <div>
                    {Object.keys(emailErrors).map((key) => {
                      return (
                        <div style={{ color: "red" }}>{emailErrors[key]}</div>
                      );
                    })}
                  </div>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group controlId="consignee">
                  <Form.Label>Role*</Form.Label>
                  <Select
                    options={roles.map((r) => ({
                      label: r.role,
                      value: r.role_value,
                    }))}
                    value={role}
                    onChange={(e) => setrole1(e)}
                    placeholder="Role"
                  />
                  <div>
                    {Object.keys(roleErrors).map((key) => {
                      return (
                        <div style={{ color: "red" }}>{roleErrors[key]}</div>
                      );
                    })}
                  </div>
                </Form.Group>
              </div>
            </div>
            <div className="row" style={{ display: showOrganization }}>
              <div className="col">
                <Form.Group>
                  <Form.Label>Organization*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Organization name"
                    value={organization}
                    onChange={(e) => setOrganization(e.target.value)}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Group controlId="consignee">
                  <Form.Label>First Name*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="First Name"
                    required
                    value={fname}
                    onChange={(e) => setFname(e.target.value)}
                  ></Form.Control>
                  <div>
                    {Object.keys(fnameErrors).map((key) => {
                      return (
                        <div style={{ color: "red" }}>{fnameErrors[key]}</div>
                      );
                    })}
                  </div>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group controlId="consignee">
                  <Form.Label>Last Name*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Last Name"
                    required
                    value={lname}
                    onChange={(e) => setLname(e.target.value)}
                  ></Form.Control>
                  <div>
                    {Object.keys(lnameErrors).map((key) => {
                      return (
                        <div style={{ color: "red" }}>{lnameErrors[key]}</div>
                      );
                    })}
                  </div>
                </Form.Group>
              </div>
            </div>
            <div className="row" style={{ display: showPassword }}>
              <div className="col-md-12" style={{ display: showPassword }}>
                <Form.Group controlId="consignee">
                  <Form.Label>Password*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="password"
                    value={pwd}
                    onChange={(e) => setpassword(e.target.value)}
                  ></Form.Control>
                  <div>
                    {Object.keys(passwordErrors).map((key) => {
                      return (
                        <div style={{ color: "red" }}>
                          {passwordErrors[key]}
                        </div>
                      );
                    })}
                  </div>
                </Form.Group>
              </div>
            </div>
            <div className="row" style={{ display: showActivationLink }}>
              <div className="col-md-12">
                <Form.Group controlId="consignee">
                  <Form.Label> Account Activation Link*</Form.Label>
                  <Select
                    options={activationlink.map((r) => ({
                      label: r.type,
                      value: r.type_id,
                    }))}
                    value={type}
                    onChange={(e) => setType1(e)}
                    placeholder="Type"
                  />
                  <div>
                    {Object.keys(typeErrors).map((key) => {
                      return (
                        <div style={{ color: "red" }}>{typeErrors[key]}</div>
                      );
                    })}
                  </div>
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Group controlId="consignee">
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Phone"
                    value={phone}
                    onChange={(e) => setphone(e.target.value)}
                  ></Form.Control>
                  <div>
                    {Object.keys(phoneErrors).map((key) => {
                      return (
                        <div style={{ color: "red" }}>{phoneErrors[key]}</div>
                      );
                    })}
                  </div>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group controlId="consignee">
                  <Form.Label>DOB</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder=""
                    value={dob}
                    onChange={(e) => setdob(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <Form.Group controlId="countri">
                  <Form.Label>Country</Form.Label>
                  <Select
                    options={countries.map((element) => ({
                      id: element.isoCode,
                      value: element.name,
                      label: element.name,
                    }))}
                    // value={{
                    //   label: postcountry,
                    //   value: postcountry,
                    // }}
                    onChange={(e) => selectCountry(e)}
                    placeholder="Country"
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group controlId="name">
                  <Form.Label>State</Form.Label>
                  <Select
                    options={dap_states.map((element) => ({
                      id: element.isoCode,
                      value: element.name,
                      label: element.name,
                    }))}
                    onChange={(e) => selectRegion(e)}
                    // defaultValue={dap_deviceList[0].name}
                    defaultValue="hi there"
                    placeholder="State"
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group controlId="name">
                  <Form.Label>City</Form.Label>
                  <Select
                    options={dap_city.map((element) => ({
                      id: element.isoCode,
                      value: element.name,
                      label: element.name,
                    }))}
                    onChange={(e) => selectCity(e)}
                    // value={{ label: postcity, value: postcity }}
                    defaultValue="hi there"
                    placeholder="City"
                  />
                </Form.Group>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <Form.Group controlId="consignee">
                  <Form.Label>Zip</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Zip"
                    value={zip}
                    onChange={(e) => setzip(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group controlId="consignee">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Button
                  variant="primary"
                  style={{ marginTop: 22 }}
                  onClick={AddLeadExecutive}
                >
                  Add
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUserSysAdmin;
